export default "__VITE_ASSET__WG1dXG6c__"